var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-kv",style:(_vm.rootStyle)},[_c('span',{style:(_vm.keyStyle)},[_vm._v(_vm._s(_vm.k))]),_vm._v(" "),_c('span',{style:(_vm.valStyle)},[_vm._v(_vm._s(_vm.v))])])
}
var staticRenderFns = []

export { render, staticRenderFns }